export default __webpack_public_path__ + "static/media/s1.8154095f.jpg";